import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

let revealContainers = document.querySelectorAll(".reveal");

if (revealContainers.length > 0) {
    revealContainers.forEach((container) => {
        let image = container.querySelector("img");

        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: container,
                once: true,
            }
        });

        tl.set(container, { autoAlpha: 1 });

        tl.from(container, {
            duration: 1.5,
            yPercent: 100,
            ease: "power2.out"
        });

        if (image) {
            tl.from(image, {
                duration: 1.5,
                yPercent: -100,
                ease: "power2.out",
                delay: -1.5
            });
        }
    });
}